// Reglage de la camera
export default function settingCameras(game) {
  game.cameras.main.startFollow(game.player);
  game.cameras.main.centerOn(0, 0);
  game.cameras.main.zoom = 1.7;
}
